import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 CÓDIGO INFIDELIDAD™',
  ideal: 'Personas que descubrieron una infidelidad y necesitan un protocolo urgente',
  was: '$38',
  now: '$19',
  features: ['12 Tomos completos', 'Protocolo de emergencia Día 1', 'Guion de confrontación estratégica', 'Sistema de decisión en frío', '5 Bonos estratégicos gratis', 'Garantía 7 días'],
  cta: 'Quiero el protocolo ahora'
};
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: CreditCardIcon,
  label: 'Crédito / Débito'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-127" data-mp="3h97ns3l1dauy">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-128" data-mp="3canwdnnob6v7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-rojo/40 bg-ink-2 px-6 pb-7 pt-10 text-center shadow-[0_20px_60px_-20px_rgba(214,31,43,0.4)]" data-id="element-129" data-mp="3vynlio2kwdf5">
          <h3 className="font-display text-lg font-black text-white" data-id="element-130" data-mp="3dasb9e66dhqs">{plan.name}</h3>
          <p className="mt-2 text-sm text-white/60" data-id="element-131" data-mp="3i8tv41bfdl3b">
            <span className="font-semibold text-white/80" data-id="element-132" data-mp="3n7ew42yi48st">Ideal para:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-133" data-mp="3rxlj5ydd7l8y">
            <span className="text-base font-medium text-white/40 line-through" data-id="element-134" data-mp="3ryn5iyztzu5z">{plan.was}</span>
            <div className="text-plata-shine font-display text-4xl font-black" data-id="element-135" data-mp="2uhek7k5l1vgg">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-rojo-soft" data-id="element-136" data-mp="2zgiwwkrpubbj">
              Pago único · Acceso de por vida
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-137" data-mp="2rei8ybdycboj">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-138" data-mp="316obug5qsdii">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-plata" strokeWidth={3} data-id="element-139" data-mp="318r2n2epyaoa" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-140" data-mp="28j202kmd22kk">
            <CTAButton size="md" data-id="element-141" data-mp="23j5s6aajlqzq">{plan.cta}</CTAButton>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-142" data-mp="23l0g7xh41z81">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="2dfimnadww8vj">
                <Icon className="h-4 w-4 text-plata" data-id="element-144" data-mp="3tuaftpivtk5w" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-145" data-mp="3oyl9n3ccx50m" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-plata/25 bg-white/[0.04] p-5 text-left" data-id="element-146" data-mp="9uce0beghhn">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-plata" data-id="element-147" data-mp="5arte9kob5hk" />
          <p className="text-[15px] leading-relaxed text-plata" data-id="element-148" data-mp="3ng4rzruw86sf">
            <span className="font-display font-bold text-white" data-id="element-149" data-mp="3rgex72av2t68">
              Garantía de devolución de 7 días.
            </span>{' '}
            Si abrís los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el
            reembolso y te devolvemos el 100%. Sin formularios, sin drama, sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}